module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/pages/customer/betoverview/betoverview.html
// module id = 1601
// module chunks = 0